import { SearchSortKeys } from 'src/generated/product-service-graphql';

export const getColorName = (colorTagFromURL: string) => {
  let searchExpression;
  if (colorTagFromURL.toLowerCase().indexOf('colorgroup') >= 0) {
    searchExpression = /colorgroup:/gi;
  } else {
    searchExpression = /color:|:color/gi;
  }
  return convertTagFromURL(colorTagFromURL).replace(searchExpression, '');
};

const convertTagFromURL = (tagFromURL: string) => {
  const tagToUpperCase = tagFromURL
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('-');
  if (tagToUpperCase.toLowerCase().startsWith('colorgroup')) {
    return tagToUpperCase.replace('Colorgroup-', 'Colorgroup:').replace(/-/g, ' ');
  } else {
    return tagToUpperCase.replace('Color-', 'Color:').replace('-Color', ':Color').replace(/-/g, ' ');
  }
};

export const validateSortBy = (sort_by: string | null) => {
  return (Object.values(SearchSortKeys).includes(sort_by as SearchSortKeys)
    ? sort_by
    : SearchSortKeys.Default) as SearchSortKeys;
};
